import React from 'react'

import { COMPONENTS_MAP, COMPONENTS_PREVIEW_MAP } from 'shared/enums/index'

import { createTheme } from 'shared/theme/index'

import ThemeContext from 'shared/components/ThemeContext'

export default (props) => {
  const RenderComponent = COMPONENTS_MAP[props.pageComponent.component.type]
  const previewAttrs = COMPONENTS_PREVIEW_MAP[props.pageComponent.component.type]

  if (!RenderComponent) {
    return <React.Fragment />
  }

  const theme = createTheme(props.theme)

  return (
    <ThemeContext theme={props.theme}>
      <RenderComponent
        theme={theme}
        attrs={previewAttrs}
      />
    </ThemeContext>
  )
}



// WEBPACK FOOTER //
// ./src/components/ComponentPreviewRenderer/index.js